<template>
    <section class="padding-vertical-content mb-3 mb-lg-4">
        <div>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <div class="mb-5">
                    <div>
                        <label class="mb-4 h5 text-uppercase">
                            Datos del responsable 1
                        </label>

                        <div class="row">
                            <div class="col-md-4 col-12">
                                <FormInput style="width: 96%; margin: auto" label="Nombre del responsable" type="text" name="nombre responsable" id="nombre_responsable" rules="required" v-model="base_data.nombre_responsable" :disabled="!paso_activo" />
                            </div>
                            <div class="col-md-4 col-12 mt-md-0 mt-4">
                                <FormInput style="width: 96%; margin: auto" label="Apellidos del responsable" type="text" name="apellidos responsable" id="apellidos_responsable" rules="required" v-model="base_data.apellidos_responsable" :disabled="!paso_activo" />
                            </div>
                            <div class="col-md-4 col-12" style="width: 96%; margin: auto">
                                <DocumentoTipo
                                    id="tipo-documento-resp1"
                                    :value="tipoDocumentoResponsable1"
                                    :index="1"
                                    :disabled="!paso_activo"
                                    @input="val => { tipoDocumentoResponsable1 = val; base_data.dni_responsable = ''; }"
                                />
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-4 col-12" style="width: 96%; margin: auto">
                                <DocumentoValor
                                    :type="tipoDocumentoResponsable1"
                                    :value="base_data.dni_responsable"
                                    :index="1"
                                    :disabled="!paso_activo"
                                    @input="val => { base_data.dni_responsable = val; }"
                                />
                            </div>
                            <div class="col-md-4 col-12 mt-md-0 mt-4">
                                <div class="form-group" style="width: 96%; margin: auto">
                                    <label>Teléfono *</label>
                                    <PhoneInput
                                        name="telefono_responsable"
                                        id="telefono_responsable"
                                        data-cy="telefono_responsable"
                                        :phone="base_data.telefono_responsable ?? null"
                                        :desactivar="!paso_activo"
                                        :required="true"
                                        :error_telefono="error_telefono_resp1"
                                        @setNumber="(number) => base_data.telefono_responsable = number"
                                        @validNumber="(valid) => telefono_valido_resp1 = valid"
                                        @onTyping="(phone) => {
                                            if (phone && phone.length > 0) {
                                                error_telefono_resp1 = 0;
                                            }
                                        }"
                                    />
                                    <span
                                        v-if="error_telefono_resp1"
                                        class="invalid-feedback text-xs error-message mt-3"
                                        style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                                    >
                                        <b>El teléfono es requerido y debe ser válido</b>
                                    </span>
                                </div>
                            </div>

                            <div class="col-md-4 col-12 customInputCss">
                                <FormInput style="width: 96%; margin: auto" label="Email del responsable" type="email" name="email responsable" id="email_responsable" rules="required" v-model="base_data.email_responsable" :disabled="!paso_activo" />
                            </div>
                        </div>

                        <div class="mt-5">
                            <label class="mb-4 h5 text-uppercase">
                                Datos del responsable 2
                            </label>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-12">
                                <FormInput style="width: 96%; margin: auto" label="Nombre del responsable 2" type="text" name="nombre del responsable" id="nombre_responsable_2" :rules="tieneAlgunDatoResponsable2 ? 'required' : ''" v-model="base_data.nombre_responsable_2" :disabled="!paso_activo" />
                            </div>
                            <div class="col-md-4 col-12 mt-md-0 mt-4">
                                <FormInput style="width: 96%; margin: auto" label="Apellidos del responsable 2" type="text" name="apellidos del responsable" id="apellidos_responsable_2" :rules="tieneAlgunDatoResponsable2 ? 'required' : ''" v-model="base_data.apellidos_responsable_2" :disabled="!paso_activo" />
                            </div>
                            <div class="col-md-4 col-12 customInputCss" style="width: 96%; margin: auto">
                                <DocumentoTipo
                                    id="tipo-documento-resp2"
                                    :value="tipoDocumentoResponsable2"
                                    :index="2"
                                    :disabled="!paso_activo"
                                    @input="val => { tipoDocumentoResponsable2 = val; base_data.dni_responsable_2 = ''; }"
                                />
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-4 col-12" style="width: 96%; margin: auto">
                                <DocumentoValor
                                    :type="tipoDocumentoResponsable2"
                                    :value="base_data.dni_responsable_2"
                                    :index="2"
                                    :disabled="!paso_activo"
                                    :required="tieneAlgunDatoResponsable2"
                                    @input="val => { base_data.dni_responsable_2 = val; }"
                                />
                            </div>
                            <div class="col-md-4 col-12 mt-md-0 mt-4">
                                <div class="form-group" style="width: 96%; margin: auto">
                                    <label>Teléfono del responsable 2 {{ tieneAlgunDatoResponsable2 ? '*' : '' }}</label>
                                    <PhoneInput
                                        name="telefono_responsable_2"
                                        data-cy="telefono_responsable_2"
                                        :phone="base_data.telefono_responsable_2 ?? null"
                                        :desactivar="!paso_activo"
                                        :required="tieneAlgunDatoResponsable2"
                                        :error_telefono="error_telefono_resp2"
                                        @setNumber="(number) => base_data.telefono_responsable_2 = number"
                                        @validNumber="(valid) => telefono_valido_resp2 = valid"
                                        @onTyping="(phone) => {
                                            if (phone && phone.length > 0) {
                                                error_telefono_resp1 = 0;
                                            }
                                        }"
                                    />
                                    <span
                                        v-if="error_telefono_resp2"
                                        class="invalid-feedback text-xs error-message mt-3"
                                        style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                                    >
                                        <b>El teléfono es requerido y debe ser válido</b>
                                    </span>
                                </div>
                            </div>

                            <div class="col-md-4 col-12 customInputCss">
                                <FormInput style="width: 96%; margin: auto" label="Email del responsable 2" type="email" name="email_responsable_2" id="email_responsable_2" :rules="tieneAlgunDatoResponsable2 ? 'required' : ''" v-model="base_data.email_responsable_2" :disabled="!paso_activo" />
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12">
                                <FormInput style="width: 98%; margin: auto" label="Observaciones" type="text" name="observaciones" id="observaciones" rules="" v-model="base_data.observaciones" :disabled="!paso_activo" />
                            </div>
                        </div>

                        <div class="col-12 text-right mt-4">
                            <button type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-1" :disabled="!paso_activo">
                                <span>{{ $t('formularios.atras') }}</span>
                            </button>
                            <button type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-2" :disabled="!paso_activo">
                                <span>{{ $t('formularios.continuar') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </section>
</template>


<script>
    import PhoneInput from '@/components/common/PhoneInput';
    import DocumentoTipo from '@/components/common/DocumentoTipo';
    import DocumentoValor from '@/components/common/DocumentoValor';

    export default {
        props: {
            base: {
                type: Object,
                required: true
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            paso_activo: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                base_data : { ...this.base },
                fields_responsable_1: {},
                fields_responsable_2: {},
                lista_id: this.$route.params.lista_id,
                error_telefono_resp1: 0,
                error_telefono_resp2: 0,
                telefono_valido_resp1: false,
                tipoDocumentoResponsable1: '',
                tipoDocumentoResponsable2: '',
                telefono_valido_resp2: false
            };
        },
        created() {
            if(window.location.href.indexOf("renovar") > -1) {

                if (!this.base_data.nombre_responsable && this.base_data.nombre_responsable_1){
                    this.base_data.nombre_responsable = this.base_data.nombre_responsable_1;
                    this.base_data.apellidos_responsable = this.base_data.apellidos_responsable_1;
                    this.base_data.dni_responsable = this.base_data.dni_responsable_1;
                    this.base_data.telefono_responsable = this.base_data.telefono_responsable_1;
                    this.base_data.email_responsable = this.base_data.email_responsable_1;
                }
            }

            this.tipoDocumentoResponsable1 = 'DNI';
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            fields() {
                return this.$store.getters.getListaAbonados.basesFields.filter(field => field.representante === true);
            },
            tieneAlgunDatoResponsable2() {
                return !!(
                    (this.base_data.nombre_responsable_2 && this.base_data.nombre_responsable_2.trim()) ||
                    (this.base_data.apellidos_responsable_2 && this.base_data.apellidos_responsable_2.trim()) ||
                    (this.base_data.dni_responsable_2 && this.base_data.dni_responsable_2.trim()) ||
                    (this.base_data.telefono_responsable_2 && this.base_data.telefono_responsable_2.trim()) ||
                    (this.base_data.email_responsable_2 && this.base_data.email_responsable_2.trim()) ||
                    Object.values(this.fields_responsable_2).some(val => val && val.toString().trim() !== '')
                );
            },
        },
        methods: {
            terminar() {
                const responsable_1 = {
                    nombre: this.base_data.nombre_responsable,
                    apellidos: this.base_data.apellidos_responsable,
                    telefono: this.base_data.telefono_responsable,
                    dni: this.base_data.dni_responsable,
                    email: this.base_data.email_responsable,
                    fields: Object.keys(this.fields_responsable_1).map(key => ({
                        name: key,
                        value: this.fields_responsable_1[key]
                    }))
                };

                const responsable_2 = {
                    nombre: this.base_data.nombre_responsable_2,
                    apellidos: this.base_data.apellidos_responsable_2,
                    dni: this.base_data.dni_responsable_2,
                    telefono: this.base_data.telefono_responsable_2,
                    email: this.base_data.email_responsable_2,
                    fields: Object.keys(this.fields_responsable_2).map(key => ({
                        name: key,
                        value: this.fields_responsable_2[key]
                    }))
                };


                let params = {
                    responsable_1,
                    lista_id: this.lista_id,
                    session_id: this.base.categoria_base.session_id,
                    filters: {
                        tid: this.configuracion.hash_teatro
                    }
                }

                if (this.tieneAlgunDatoResponsable2) {
                    params.responsable_2 = responsable_2;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.guardar-datos-responsables'), params).then(res => {
                    this.base_data.categoria_base.session_id = res.data.session_id;
                });

                this.base_data.fields_responsable_1 = responsable_1.fields;
                if(this.tieneAlgunDatoResponsable2)
                {
                    this.base_data.fields_responsable_2 = responsable_2.fields;
                }
                this.$emit("guardarBase", this.base_data);
                this.$emit('terminado');
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();

                const telefono_resp1_valido = this.telefono_valido_resp1 && this.base_data.telefono_responsable;
                const telefono_resp2_valido = !this.tieneAlgunDatoResponsable2 || (this.telefono_valido_resp2 && this.base_data.telefono_responsable_2);

                if (isValid && telefono_resp1_valido && telefono_resp2_valido) {
                    this.error_telefono_resp1 = 0;
                    this.error_telefono_resp2 = 0;
                    this.terminar();
                } else {
                    if (!telefono_resp1_valido) {
                        this.error_telefono_resp1 = 1;
                    }
                    if (!telefono_resp2_valido && this.tieneAlgunDatoResponsable2) {
                        this.error_telefono_resp2 = 1;
                    }
                }
            },
            volver() {
                this.$emit("guardarBase", this.base_data);
                this.$emit('volver');
            },
            checkAndInitResponsable2(newVal) {
                if (newVal && newVal.trim() && !this.tipoDocumentoResponsable2) {
                    this.tipoDocumentoResponsable2 = 'DNI';
                }
            },
        },
        watch: {
            'base_data.nombre_responsable_2': 'checkAndInitResponsable2',
            'base_data.apellidos_responsable_2': 'checkAndInitResponsable2',
            'base_data.telefono_responsable_2': 'checkAndInitResponsable2',
            'base_data.email_responsable_2': 'checkAndInitResponsable2',
            'base_data.observaciones': 'checkAndInitResponsable2',

            tieneAlgunDatoResponsable2(newVal) {
                if (!newVal && this.tipoDocumentoResponsable2) {
                    this.tipoDocumentoResponsable2 = '';
                    this.base_data.dni_responsable_2 = '';
                }
            }
        },
        components: {
            PhoneInput,
            DocumentoTipo,
            DocumentoValor
        }
    };
</script>
